import { getAsset } from '@/utils';
import { ImageTitleLink, NameValueType } from '@/types';
import { MallType } from '@remodeling/content';

export const NO_SWIPE_AREA = 'no-swiping';

export const DRAWER_SNS_LINKS: ImageTitleLink[] = [
  {
    title: '플러스친구',
    img: getAsset('/common/ic_kakao.png'),
    link: 'http://pf.kakao.com/_xjWlKu',
  },
  {
    title: '인스타그램',
    img: getAsset('/common/ic_insta.png'),
    link: 'https://www.instagram.com/hanssem_official/',
  },
  {
    title: '유튜브',
    img: getAsset('/common/ic_youtube.png'),
    link: 'https://www.youtube.com/c/%ED%95%9C%EC%83%98%EC%9C%A0%ED%8A%9C%EB%B8%8C',
  },
  {
    title: '네이버 포스트',
    img: getAsset('/common/ic_naver.png'),
    link: 'https://m.post.naver.com/my.naver?memberNo=46828087',
  },
];

export const DRAWERLIST = () => {
  const DRAWER_ONE_DEPTH_ITEMS: (NameValueType<MallType> & {
    selectedDotColor: string;
  })[] = [
    {
      name: '스토어',
      value: 'MALL',
      selectedDotColor: '#FF3C3C',
    },
    {
      name: '인테리어',
      value: 'REMODELING',
      selectedDotColor: '#0064FF',
    },
    {
      name: '홈아이디어',
      value: 'HOMEIDEA',
      selectedDotColor: '#FFB43C',
    },
  ];

  return DRAWER_ONE_DEPTH_ITEMS;
};

export const HANSSEM_MALL_CALL = '1688-4945';
export const AS_CENTER_CALL = '1588-0900';

export const KAKAO_MALL_CENTER_LINK =
  'https://chat.eumnet.com/api/kakao/chat_open?yid=@한샘온라인고객센터';
export const KAKAO_AS_CENTER_LINK =
  'https://chat.eumnet.com/api/kakao/chat_open?yid=@hswebas';
